import { useReveal } from "@/hooks/useReveal";

const ITEMS = [
  {
    icon: "ri-focus-3-line",
    title: "Small runs are the point, not the exception",
    body: "Our minimum is published below, so you can decide before you write to us. If your volume is under it, we will tell you straight away rather than waste a month of your time.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Our certification enables your claim",
    body: "The organic seal on a finished pack has to hold up in the country you sell into. We process under Ecocert USDA and EU Organic, and we hand over the certificates and process documentation your own certifier will ask to see.",
  },
  {
    icon: "ri-fingerprint-line",
    title: "You keep your brand",
    body: "The artwork, the recipe file and the brand are yours. We manufacture and pack. We do not register your brand, we do not sell it, and we do not use it.",
  },
  {
    icon: "ri-route-line",
    title: "You retain your brand",
    body: "The design and brand belong to you. We handle manufacturing and packaging. We do not register, sell, or use your brand.",
  },
];

export default function EmergingBrands() {
  const ref = useReveal<HTMLDivElement>();

  return (
    <section id="emerging-brands" className="bg-white py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div ref={ref} className="reveal max-w-2xl">
          <h2 className="text-ink font-serif text-3xl md:text-4xl font-semibold">
            For founders and emerging brands
          </h2>
          <p className="mt-4 text-ink/70 text-lg leading-relaxed">
            The problem is almost always the same. You have a product and a
            market, and the plants that will actually make it either demand
            volumes you cannot commit to, or they already own a competing
            brand on the same shelf. We are small enough that your run is worth
            our time, and we do not sell a competing brand into the channel we
            agree with you.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-6">
          {ITEMS.map((item) => (
            <div
              key={item.title}
              className="bg-cream/60 rounded-lg p-7 border border-cream-dark/50"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-full bg-white border border-cream-dark/60 text-brown">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="mt-4 text-ink font-serif text-lg md:text-xl font-semibold">
                {item.title}
              </h3>
              <p className="mt-2 text-ink/70 text-[17px] leading-relaxed">
                {item.body}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-10">
          <a
            href="#quote"
            className="inline-flex items-center gap-2 text-brand font-semibold text-base hover:underline"
          >
            Request a private label proposal
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}